<header class="fixed-header">
  <div class="header-container">
    <div class="left-section">
      <!-- Logo -->
      <a [routerLink]="isLoggedIn ? '/dashboard' : '/'" class="logo-link">Weddingly Matrimony</a>

      <!-- Desktop Navigation -->
      <nav class="desktop-nav" *ngIf="isLoggedIn">
        <a routerLink="/dashboard" routerLinkActive="active" [routerLinkActiveOptions]="{exact: true}">Dashboard</a>
        <a *ngIf="currentPlan === 'EXPRESS' || currentPlan === 'PLATINUM'" routerLink="/express-concierge"
          routerLinkActive="active" class="vip-concierge-link">
          <i class="bi bi-stars"></i>
          <span>Personal Match Manager</span>
          <span class="pro-badge-mini">PRO</span>
        </a>
        <a routerLink="/profiles" routerLinkActive="active">Search</a>
        <a routerLink="/partner-preferences" routerLinkActive="active">Partner Preferences</a>
        <a routerLink="/chat" routerLinkActive="active">
          Inbox
          <span *ngIf="unreadMessageCount > 0" class="inbox-badge">{{ unreadMessageCount }}</span>
        </a>
        <a routerLink="/interests" routerLinkActive="active">
          Interests
          <span *ngIf="unreadInterestCount > 0" class="inbox-badge">{{ unreadInterestCount }}</span>
        </a>
        <a routerLink="/favorites" routerLinkActive="active">Favorites</a>
        <a routerLink="/plans" routerLinkActive="active">Plans</a>
        <a routerLink="/divorced" routerLinkActive="active">Divorced</a>
        <a routerLink="/discover/widowed" routerLinkActive="active">Widowed</a>
        <a routerLink="/wedding-services" routerLinkActive="active">Services</a>
        <a routerLink="/support" routerLinkActive="active">Support</a>
      </nav>
    </div>

    <!-- Right Section -->
    <div class="right-section">
      <ng-container *ngIf="!isLoggedIn; else loggedInHeader">
        <a routerLink="/merchant/register" class="merchant-btn">Become a Merchant</a>
        <a routerLink="/merchant/login" class="merchant-login-btn">Merchant Login</a>
        <a routerLink="/broker/login" class="portal-link broker-link" title="Broker Portal (Login / Register)">
          <span class="material-symbols-outlined">handshake</span> Broker Portal
        </a>
        <a routerLink="/admin/login" class="portal-link admin-link" title="Admin Login">
          <span class="material-symbols-outlined">admin_panel_settings</span> Admin
        </a>
        <a routerLink="/login" class="maroon-outline-button sign-in-btn">Sign In</a>
        <a routerLink="/signup-basic" class="gold-button join-btn">Join Free</a>
      </ng-container>

      <ng-template #loggedInHeader>
        <!-- Notification Bell -->
        <div class="notification-container relative mr-2">
          <button class="icon-button" (click)="toggleNotifications()" aria-label="Notifications"
            title="Who viewed your profile">
            <span class="material-symbols-outlined">notifications</span>
            <span *ngIf="unreadNotificationCount > 0" class="notification-badge">{{ unreadNotificationCount }}</span>
          </button>

          <div class="notification-dropdown !w-[320px] md:!w-[350px]" *ngIf="showNotifications">
            <div class="dropdown-header flex justify-between items-center bg-primary/5 p-3 border-b">
              <h3 class="font-bold text-primary flex items-center gap-1.5 text-sm m-0">
                <span class="material-symbols-outlined text-[18px]">visibility</span> Profile Visitors
              </h3>
              <span *ngIf="!hasNotificationAccess"
                class="text-[10px] bg-amber-100 text-amber-800 px-2 py-0.5 rounded-full font-bold">Gold Feature</span>
            </div>

            <!-- List -->
            <ul class="dropdown-list max-h-[320px] overflow-y-auto divide-y divide-gray-100 m-0 p-0"
              *ngIf="notifications && notifications.length > 0; else emptyNotifs">
              <li *ngFor="let item of notifications" class="p-3 hover:bg-gray-50 transition-all flex items-start gap-3">
                <ng-container *ngIf="item.is_rm_notification; else standardNotif">
                  <div
                    class="w-8 h-8 rounded-full bg-[#B01E3E]/15 text-[#B01E3E] flex items-center justify-center shrink-0 border border-[#B01E3E]/30">
                    <span class="material-symbols-outlined text-[18px]">workspace_premium</span>
                  </div>
                  <div class="flex-grow min-w-0">
                    <div class="flex items-baseline justify-between gap-1">
                      <p class="font-bold text-xs text-[#B01E3E] uppercase tracking-wider m-0">
                        {{ item.title }}
                      </p>
                      <span class="text-[10px] text-gray-400 shrink-0">{{ getTimeAgo(item.viewed_at) }}</span>
                    </div>
                    <p class="text-xs text-gray-700 font-medium mt-1 mb-1 leading-relaxed">
                      {{ item.message }}
                    </p>
                    <div *ngIf="item.rm_name"
                      class="bg-pink-50/80 border border-pink-200/60 rounded-xl p-2.5 mt-1.5 space-y-1">
                      <div class="flex items-center justify-between text-xs font-bold text-gray-800">
                        <span>👤 {{ item.rm_name }}</span>
                        <span class="text-[10px] bg-pink-200/80 text-[#B01E3E] px-1.5 py-0.5 rounded font-extrabold">{{
                          item.rm_employee_id }}</span>
                      </div>
                      <div class="text-[11px] text-gray-600 flex items-center gap-1">
                        <span class="material-symbols-outlined text-[13px] text-gray-400">call</span> {{ item.rm_phone
                        }}
                      </div>
                      <div class="flex items-center gap-2 pt-1">
                        <a routerLink="/dashboard" (click)="showNotifications = false"
                          class="flex-1 py-1.5 px-2 bg-[#B01E3E] hover:bg-rose-900 text-white rounded-lg text-[11px] font-bold text-center no-underline transition-colors shadow-xs">
                          💬 Chat with RM
                        </a>
                        <a [href]="'tel:' + item.rm_phone"
                          class="flex-1 py-1.5 px-2 border border-[#B01E3E] text-[#B01E3E] hover:bg-pink-100/50 rounded-lg text-[11px] font-bold text-center no-underline transition-colors">
                          📞 Call RM
                        </a>
                      </div>
                    </div>
                  </div>
                </ng-container>
                <ng-template #standardNotif>
                  <div class="w-8 h-8 rounded-full flex items-center justify-center shrink-0"
                    [ngClass]="item.is_masked ? 'bg-amber-100 text-amber-600' : 'bg-primary/10 text-primary'">
                    <span class="material-symbols-outlined text-[16px]">{{ item.is_masked ? 'lock' : 'person' }}</span>
                  </div>
                  <div class="flex-grow min-w-0">
                    <div class="flex items-baseline justify-between gap-1">
                      <p class="font-semibold text-sm text-gray-800 truncate m-0"
                        [ngClass]="{'blur-[3px] select-none': item.is_masked}">
                        {{ item.viewer_name }}
                      </p>
                      <span class="text-[11px] text-gray-400 shrink-0">{{ getTimeAgo(item.viewed_at) }}</span>
                    </div>
                    <p *ngIf="!item.is_masked" class="text-xs text-gray-500 mt-0.5 mb-0">
                      Viewed your profile details
                    </p>
                    <p *ngIf="item.is_masked" class="text-xs text-amber-700 font-medium mt-1 mb-0">
                      {{ item.upgrade_message }}
                    </p>
                    <a *ngIf="!item.is_masked && item.viewer_id" [routerLink]="['/profile-details', item.viewer_id]"
                      (click)="showNotifications = false"
                      class="inline-block mt-1.5 text-xs text-primary font-bold hover:underline">
                      View Profile →
                    </a>
                    <a *ngIf="item.is_masked" routerLink="/plans" (click)="showNotifications = false"
                      class="inline-block mt-1.5 text-xs bg-gradient-to-r from-amber-500 to-yellow-600 text-white px-2.5 py-1 rounded-lg font-bold shadow-xs hover:opacity-90">
                      Upgrade to Gold →
                    </a>
                  </div>
                </ng-template>
              </li>
            </ul>

            <ng-template #emptyNotifs>
              <div class="empty-notifications p-6 text-center text-gray-400">
                <span
                  class="material-symbols-outlined text-[36px] text-gray-300 block mx-auto mb-2">notifications_off</span>
                <p class="text-sm font-medium text-gray-600 m-0">No profile visitors yet</p>
                <p class="text-xs text-gray-400 mt-1 m-0">When matches view your profile, they will appear here.</p>
              </div>
            </ng-template>
          </div>
        </div>

        <!-- User Profile Dropdown -->
        <div class="user-profile-menu">
          <button class="profile-avatar-btn" (click)="toggleProfileDropdown()" aria-label="Profile Menu">
            <img
              [src]="currentUserImage ? 'data:image/jpeg;base64,' + currentUserImage : 'assets/images/profiles/1.jpg'"
              alt="User Avatar">
          </button>

          <div class="profile-dropdown" *ngIf="isProfileDropdownOpen">
            <div class="profile-header-info">
              <span class="user-name">{{ currentUser?.basic_info?.first_name }} {{ currentUser?.basic_info?.last_name
                }}</span>
              <span class="user-email">{{ currentUser?.basic_info?.email }}</span>
            </div>
            <div class="dropdown-divider"></div>
            <a routerLink="/dashboard" (click)="isProfileDropdownOpen = false" class="dropdown-link">
              <span class="material-symbols-outlined">dashboard</span> Dashboard
            </a>
            <a routerLink="/my-profile" (click)="isProfileDropdownOpen = false" class="dropdown-link">
              <span class="material-symbols-outlined">person</span> My Profile
            </a>
            <a routerLink="/partner-preferences" (click)="isProfileDropdownOpen = false" class="dropdown-link">
              <span class="material-symbols-outlined">settings</span> Preferences
            </a>
            <a routerLink="/my-horoscope" (click)="isProfileDropdownOpen = false" class="dropdown-link">
              <span class="material-symbols-outlined">auto_awesome</span> Horoscope
            </a>
            <a routerLink="/interests" (click)="isProfileDropdownOpen = false" class="dropdown-link">
              <span class="material-symbols-outlined">favorite</span> Interests
            </a>
            <a routerLink="/favorites" (click)="isProfileDropdownOpen = false" class="dropdown-link">
              <span class="material-symbols-outlined">star</span> Favorites
            </a>
            <a routerLink="/plans" (click)="isProfileDropdownOpen = false" class="dropdown-link">
              <span class="material-symbols-outlined">credit_card</span> Plans
            </a>
            <a routerLink="/support" (click)="isProfileDropdownOpen = false" class="dropdown-link">
              <span class="material-symbols-outlined">headset_mic</span> Contact Support
            </a>
            <a routerLink="/my-tickets" (click)="isProfileDropdownOpen = false" class="dropdown-link">
              <span class="material-symbols-outlined">inbox</span> My Support Tickets
            </a>
            <div class="dropdown-divider"></div>
            <button (click)="logout(); isProfileDropdownOpen = false" class="dropdown-link logout-btn">
              <span class="material-symbols-outlined">logout</span> Log Out
            </button>
          </div>
        </div>
      </ng-template>

      <!-- Mobile Menu Button -->
      <button class="mobile-menu-btn" (click)="toggleMenu()" aria-label="Toggle Menu">
        <span class="material-symbols-outlined">{{ isMenuOpen ? 'close' : 'menu' }}</span>
      </button>
    </div>
  </div>

  <!-- Mobile Dropdown Navigation -->
  <div class="mobile-nav" *ngIf="isMenuOpen">

  <!-- Guest User Menu -->
  <ng-container *ngIf="!isLoggedIn">

    <a routerLink="/merchant/register" (click)="isMenuOpen = false">
      Become a Merchant
    </a>

    <a routerLink="/merchant/login" (click)="isMenuOpen = false">
      Merchant Login
    </a>

    <a routerLink="/broker/login" (click)="isMenuOpen = false">
      Broker Portal
    </a>

    <a routerLink="/admin/login" (click)="isMenuOpen = false">
      Admin Login
    </a>

    <a routerLink="/login" (click)="isMenuOpen = false">
      Sign In
    </a>

    <a routerLink="/signup-basic" (click)="isMenuOpen = false">
      Join Free
    </a>

  </ng-container>


  <!-- Logged In User Menu -->
  <ng-container *ngIf="isLoggedIn">

    <a routerLink="/dashboard"
       routerLinkActive="active"
       (click)="isMenuOpen = false">
      Dashboard
    </a>

    <a routerLink="/profiles"
       routerLinkActive="active"
       (click)="isMenuOpen = false">
      Search Profiles
    </a>

    <a routerLink="/partner-preferences"
       routerLinkActive="active"
       (click)="isMenuOpen = false">
      Partner Preferences
    </a>

    <a routerLink="/my-horoscope"
       routerLinkActive="active"
       (click)="isMenuOpen = false">
      Horoscope
    </a>

    <a routerLink="/chat"
       routerLinkActive="active"
       (click)="isMenuOpen = false">
      Inbox
    </a>

    <a routerLink="/interests"
       routerLinkActive="active"
       (click)="isMenuOpen = false">
      Interests
    </a>

    <a routerLink="/favorites"
       routerLinkActive="active"
       (click)="isMenuOpen = false">
      Favorites
    </a>

    <a routerLink="/plans"
       routerLinkActive="active"
       (click)="isMenuOpen = false">
      Plans
    </a>

    <a routerLink="/divorced"
       routerLinkActive="active"
       (click)="isMenuOpen = false">
      Divorced
    </a>

    <a routerLink="/discover/widowed"
       routerLinkActive="active"
       (click)="isMenuOpen = false">
      Widowed
    </a>

    <a routerLink="/wedding-services"
       routerLinkActive="active"
       (click)="isMenuOpen = false">
      Services
    </a>

    <a routerLink="/support"
       routerLinkActive="active"
       (click)="isMenuOpen = false">
      Contact Support
    </a>

    <a routerLink="/my-tickets"
       routerLinkActive="active"
       (click)="isMenuOpen = false">
      My Tickets
    </a>

  </ng-container>

</div>
</header>